import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fromPromise} from 'rxjs/internal-compatibility';
import {filter, finalize, switchMap, takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';
import {Contract, Employee} from '../../employees/employees.model';
import {EmployeesService} from '../../employees/employees.service';
import {ModalService} from '../../modal';
import {User, UserService} from '../user.service';

@Component({
  selector: 'gp-user-action-list',
  templateUrl: './user-action-list.component.html',
  styleUrls: ['./user-action-list.component.scss']
})
export class UserActionListComponent extends Destroyable implements OnInit {

  @Input()
  public employee: Employee;

  @Input()
  public isTransferAccessMenuVisible = false;

  @Input()
  public isExternalAdmin = false;

  @Input()
  public restrictedConfidentialityTypes: string[] = [];

  @Input()
  public contract: Contract;

  @Input()
  public readonly = false;

  @Output()
  public userUpdate: EventEmitter<Employee> = new EventEmitter<Employee>();

  @Output()
  public userDeleted: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  public adminUserUpdate: EventEmitter<User> = new EventEmitter<User>();

  @Output()
  public modalOpen: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private userService: UserService,
    private modalService: ModalService,
    private employeesService: EmployeesService) {

    super();
  }

  ngOnInit() {
  }

  public openCreateUserModal() {
    this.modalOpen.emit(true);
    this.modalService.openModalWithName('CreateUserModalComponent').then((modalRef: any) => {
      modalRef.instance.employee = this.employee;
      modalRef.instance.contract = this.contract;
      this.userService.createdUser.subscribe((createdUser: Employee) => {
        this.userUpdate.emit(createdUser);
      });
    });
  }


  public activateUser(activate: boolean) {
    this.modalOpen.emit(true);
    const confirm: Promise<boolean> = this.modalService.confirm({
      'title': 'FORMS.confirm',
      'text': `SETTINGS.user_rights.${activate ? 'activate_user' : 'deactivate_user'}_confirm`,
      'type': 'warning'
    });

    fromPromise(confirm)
      .pipe(
        filter(result => result)
      )
      .subscribe(() => {
        this.sendActivateRequest(activate);
      });
  }


  private sendActivateRequest(activate: boolean) {
    const params: { activate: boolean; cliEmpIds: number[] } = {
      activate: activate,
      cliEmpIds: [this.employee.id]
    };

    this.userService.activateUser(params)
      .pipe(
        switchMap(() => this.employeesService.getEmployeeById(this.employee.id))
      )
      .subscribe((result) => {
        this.userUpdate.emit(result);
      });
  }

  public sendDeleteUserRequest(employeeId: number) {
    this.userService.deleteUser(employeeId).pipe(tap(() => this.userDeleted.emit(employeeId))).subscribe();
  }

  public openDeleteUserModal(id: number) {
    this.modalOpen.emit(true);
    const confirm: Promise<boolean> = this.modalService.confirm({
      'title': 'FORMS.confirm',
      'text': 'SETTINGS.user_rights.delete_user_confirm',
      'type': 'danger'
    });

    fromPromise(confirm)
      .pipe(
        filter(result => result),
        tap(() => {
          this.sendDeleteUserRequest(id);
        }),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();
  }

  public openTransferUserAccessModal(user: Employee) {
    this.modalOpen.emit(true);
    this.modalService.openModalWithName('TransferUserAccessModalComponent').then((modalRef: any) => {
      modalRef.instance.isExternalAdmin = this.isExternalAdmin;
      modalRef.instance.user = user;
      modalRef.instance.restrictedConfidentialityTypes = this.restrictedConfidentialityTypes;
    });
  }
}
